import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Dispatch, iRootState } from '../../../store';
import { paths } from '../../Root/paths';
import { useAsync, useParams } from '../../../hooks';
import { IGetWorkingTimeParams } from '../../../services/ReportService';
import { Col, Radio, RadioChangeEvent, ConfigProvider, Row } from 'antd';

import Content from '../../../components_/Content';
import Spinner from '../../../components_/Spinner';
import EmptyState from '../../../components_/EmptyState';
import Pagination from '../../../components_/Pagination';

import Filter from './Filter';
import List from './List';

const initialFilter: Omit<IGetWorkingTimeParams, 'pageIndex'> = {
  listOfEmployees: [],
  from: new Date().toDateString(),
  to: new Date().toDateString(),
  timeDiffSeconds: 15,
  timeTableId: undefined
};

const mapState = (state: iRootState) => ({
  data: state.reportWorkingTime.data,
  list: state.reportWorkingTime.list
});

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    getData: d.reportWorkingTime.getData,
    getList: d.reportWorkingTime.getList,
    resetList: d.reportWorkingTime.resetList,
    exportList: d.reportWorkingTime.exportList,
    reset: d.reportWorkingTime.reset
  };
};

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

export type IProps = connectedProps;

const WorkingTime: FC<IProps> = ({
  data,
  list: { data: list, pagesCount },
  getData,
  getList,
  resetList,
  exportList,
  reset
}) => {
  const [runGetData, isLoadingGetData, isGetDataLoadingError] = useAsync(getData, true);
  const [runGetList, isLoadingGetList, isGetListLoadingError] = useAsync(getList);
  const [runExportList, isLoadingExportList, isExportListLoadingError] = useAsync(exportList);

  const [filterType, setFilterType] = useState('Table');

  const {
    pageIndex,
    filter,
    handlePageChange,
    handleFilterChange,
    handleFilterApply,
    handleFilterReset
  } = useParams(initialFilter, (params) => runGetList({ ...params, filterType }), false);
  const handleFilterMode = ({ target: { value } }: RadioChangeEvent) => {
    handleFilterReset(true);
    resetList();
    setFilterType(value);
  };

  useEffect(() => {
    runGetData();

    return () => {
      reset();
    };
  }, []);

  const isLoading = isLoadingGetData || isLoadingGetList;
  const isLoadingError = isGetDataLoadingError || isGetListLoadingError || isExportListLoadingError;

  const handleExportList = () => {
    runExportList({ ...filter, filterType });
  };

  const title = 'Рабочее время';

  return (
    <Content
      breadcrumb={[{ name: 'Отчёты', url: paths.reports.root }, { name: title }]}
      title={title}
    >
      {!isLoadingGetData && !isGetDataLoadingError && (
        <>
          <Row>
            <Col span={24}>
              <ConfigProvider
                theme={{
                  components: {
                    Radio: {
                      // buttonBg: '#F2F3F7',
                      // // buttonCheckedBg: '#FFFFFF',
                      // colorPrimary: '#FFFFFF',
                      // colorPrimaryHover: '#FFFFFF',
                      // colorPrimaryActive: '#FFFFFF',
                      // colorBorderPrimary: '#d9d9d9',
                      // // colorPrimaryBorder: '#d9d9d9',
                      // buttonSolidCheckedColor: '#000000',
                      // buttonSolidCheckedBorderColor: '#d9d9d9',
                      borderRadius: 0
                      // borderBottomWidth: 5,
                      // controlOutline: '#d9d9d9'
                    }
                  }
                }}
              >
                <Radio.Group
                  style={{
                    marginTop: '-36px',
                    float: 'right',
                    border: 10,
                    borderColor: '#d9d9d9'
                  }}
                  block
                  options={[
                    { label: 'За смену', value: 'Table', style: { minWidth: '100px' } },
                    { label: 'За период', value: 'Range', style: { minWidth: '100px' } }
                  ]}
                  // defaultValue="Range"
                  optionType="button"
                  buttonStyle="solid"
                  onChange={handleFilterMode}
                  value={filterType}
                />
              </ConfigProvider>
            </Col>
          </Row>
          <Filter
            data={data}
            filter={filter}
            isLoadingGetList={isLoadingGetList}
            isLoadingExportList={isLoadingExportList}
            list={list}
            onChange={handleFilterChange}
            onClickApply={handleFilterApply}
            onClickExport={handleExportList}
            onClickReset={() => {
              handleFilterReset(true);
              resetList();
            }}
            filterType={filterType}
          />
          {!isLoading && !isLoadingError && (
            <>
              {!list && <EmptyState variant="generateReport" />}
              {list && (
                <>
                  {!Boolean(list.length) && <EmptyState variant="emptyReport" />}
                  {Boolean(list.length) && (
                    <>
                      <List list={list} />
                      <Pagination
                        pageIndex={pageIndex}
                        pagesCount={pagesCount}
                        onPageChange={handlePageChange}
                      />
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
      {isLoading && <Spinner />}
      {isLoadingError && <EmptyState variant="serverError" />}
    </Content>
  );
};

const withConnect = connect(mapState, mapDispatch);

export default withConnect(WorkingTime);
